import FormInputBase from './FormInputBase'
import FormGroup from '@mui/material/FormGroup'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Tooltip from '@mui/material/Tooltip'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { alpha } from '@mui/material/styles'

const FormCheckboxList = ({ itemProps = {}, formProps = {}, inputConfig = {} }) => {
  const { options, onSubmit, inputBaseProps } = inputConfig || {}
  const { field: { value = [], onChange, ...fieldProps } = {}, fieldState: { error } = {} } =
    formProps || {}

  const { disabled, label, tooltip } = itemProps || {}

  const handleToggle = val => {
    const newValue = value.includes(val) ? value.filter(item => item !== val) : [...value, val]
    onChange(newValue)
    if (onSubmit) onSubmit(newValue)
  }

  const renderLabel = () => {
    if (!label) return null
    return (
      <>
        {label}
        {tooltip && (
          <Tooltip
            title={tooltip}
            placement="right-end"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: theme => theme.palette.secondary_140.main,
                  color: theme => `${theme.palette.secondary_80.main} !important`,
                  fontSize: 12,
                  maxWidth: 500,
                  whiteSpace: 'pre-line',
                  wordBreak: 'break-word',
                },
              },
            }}
          >
            <HelpOutlineOutlinedIcon
              fontSize="small"
              sx={{ color: alpha('#000', 0.25), verticalAlign: 'middle', ml: 1 }}
            />
          </Tooltip>
        )}
      </>
    )
  }

  return (
    <FormInputBase
      label={renderLabel()}
      error={error}
      onSubmit={
        onSubmit
          ? () => {
              onSubmit(fieldProps.value)
            }
          : null
      }
      disabled={disabled}
      inputBaseProps={inputBaseProps}
    >
      <FormGroup row {...fieldProps}>
        {options.map(option => {
          const { label: optLabel, value: optValue, ...optionProps } = option

          return (
            <FormControlLabel
              key={`chkbxls_${optValue}}`}
              value={optValue}
              label={optLabel}
              control={
                <Checkbox
                  checked={value.includes(optValue)}
                  onChange={() => handleToggle(optValue)}
                />
              }
              {...optionProps}
            />
          )
        })}
      </FormGroup>
    </FormInputBase>
  )
}

export default FormCheckboxList
